import {RemoteSearchFilterPayload} from 'mars-modules';

export class AssetControlGroupSearchCriteria {
  userId: number;
  pageIndex: number;
  takeRows: number;
  filters: RemoteSearchFilterPayload[];
  sorts: { sortBy: string, sortDirection: string }[];

  constructor(userId: number, pageIndex: number, takeRows: number, filters: RemoteSearchFilterPayload[], sorts: { sortBy: string, sortDirection: string }[]) {
    this.userId = userId;
    this.pageIndex = pageIndex;
    this.takeRows = takeRows;
    this.filters = filters;
    this.sorts = sorts;
  }
}
